module.exports = __webpack_public_path__ + "media/images/shark/SharkMainImage-548e32b7c0baa7f2a1e4a79fd0f65ece.jpg";